const getMonth = () =>
(
  (new window.Date().getMonth() + 1).toString().padStart(2, '0')
);

const getDate = () =>
(
  new window.Date().getDate().toString().padStart(2, '0')
);

export const date_get = () =>
(
  `${ new Date().getFullYear() }-${ getMonth() }-${ getDate() }`
);